export default __webpack_public_path__ + "static/media/menu-05-api-w.81e66c55.svg";